import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, LabelList, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';

import './investmentChart.css';
import "../../common/css/component.css";

const rootStyles = getComputedStyle(document.documentElement);
const color = rootStyles.getPropertyValue("--chart-color-6").trim();
const chartTextColor = rootStyles.getPropertyValue("--chart-text-color-primary").trim();

const InvestmentChart = ({ data }) => {

  // Sorting data in ascending order by investmentDate
  data.sort((a, b) => {
    if (a.investmentAmount < b.investmentAmount) {
      return 1;
    }
    if (a.investmentAmount > b.investmentAmount) {
      return -1;
    }
    return 0;
  });
  

  // Define this outside the component
const formatCurrency = (value) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  
  return formatter.format(value);
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const investmentDate = new Date(payload[0].payload.investmentDate);
    const formattedDate = format(investmentDate, 'do MMM, yyyy');
  
    return (
      <div className="custom-tooltip">
        <p><span className="bold-label">Portfolio Company:</span> {payload[0].payload.portcoName}</p>
        <p><span className="bold-label">Investment Date:</span> {formattedDate}</p>
        <p><span className="bold-label">Investment Amount:</span> {formatCurrency(payload[0].payload.investmentAmount)}</p>
      </div>
    );
  }

  return null;
};

const formatDate = (tickItem) => {
  const tickDate = new Date(tickItem);
  return format(tickDate, 'do MMM, yyyy');
};

  return (
    <div className="component-container-no-border">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          layout="horizontal"
          data={data}
          margin={{
            top: 10,
            right: 10,
            left: 10,
            bottom: 75,
          }}
        >
          
          <XAxis dataKey="portcoName" angle={90} textAnchor="start" dx={0} dy={10}  interval={0} tick={{ fill: 'chartTextColor' }}/>
          <YAxis tickFormatter={formatCurrency} />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="investmentAmount" fill={color} >
          <LabelList 
            dataKey="investmentAmount" 
            position="inside" 
            formatter={formatCurrency} 
            angle={90} 
            style={{ fontSize: '10px', fill: '#fff' }}
          />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default InvestmentChart;
